<template>
  <PSwitch
    inset
    v-model="theme"
    color="primary"
    style="margin-top: 5px"
    :prepend-icon="theme ? 'fa-sun' : 'fa-moon'"
  />
</template>

<script>
export default {
  name: "p-theme-switch",

  components: { PSwitch: () => import("../PForm/PSwitch/PSwitch.vue") },

  data: () => ({
    theme: true,
  }),

  mounted() {
    if (this.$vuetify.theme.dark) {
      this.theme = null;
    } else {
      this.theme = true;
    }
  },

  watch: {
    theme: {
      handler() {
        if (this.theme) {
          this.$vuetify.theme.dark = false;
        } else {
          this.$vuetify.theme.dark = true;
        }
      },
    },
  },
};
</script>
